import NavBarContainer from "./NavBar/NavBarContainer";

/**
 * NavBar component - entry point
 * Uses the refactored NavBarContainer from the NavBar directory
 */
function NavBar(props) {
  return <NavBarContainer {...props} />;
}

export default NavBar;
